<template>
    <div class="space-y-4">
        <UFormGroup label="Message" required>
            <UTextarea
                :model-value="modelValue?.body ?? ''"
                @update:model-value="patch({ body: $event })"
                :rows="6"
                placeholder="Hi {{first_name}}, your plan renews on {{renews_on}}."
                size="xl"
            />
        </UFormGroup>
        <p class="text-xs text-gray-400">
            Use <code v-pre>{{variable_name}}</code> placeholders. Meta reviews this text before it can be sent.
        </p>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: any }>()
const emit = defineEmits<{ 'update:modelValue': [any] }>()

function patch(partial: Record<string, any>) {
    emit('update:modelValue', { ...(props.modelValue ?? {}), ...partial })
}
</script>
